// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"a248bd37","236":"8196748f","257":"a713d719","287":"32795235","589":"96cd4fd5","645":"1b8de241"}[chunkId] + ".chunk.css";
};